module.exports = __webpack_public_path__ + "static/Airship-bd63d1be014d01671a9fe7bd43fbde74.svg";